import {Box, HStack, Badge, Avatar, Menu, MenuButton, MenuList, MenuItem, Button, VStack} from '@chakra-ui/react';
import {useNavigate} from "react-router-dom";
import "../sass/usercard.scss";
import React, {useState} from 'react';
import ModalAtendimentos from "../modal/ModalAtendimentos";
import {ApiGestorMed} from "../api/ApiGMed";

export default function CardUsuario(props) {
    const navigate = useNavigate();
    const [showNotifications, setShowNotifications] = useState(false);
    const [atendimentos, setAtendimentos] = useState([]);

    // Função para obter a inicial do nome
    const getAtendimentos = async (obj) => {
        const cpf = props.dados.cpf;
        const data = await ApiGestorMed.getAtendimentos(cpf);
        return data;
    }
    // Função para atualizar apenas os atendimentos sem fechar o modal
    const updateAtendimentos = async () => {
        const carregado = await getAtendimentos();
        if (carregado) {
            setAtendimentos(carregado);
        }
    };
    // Função para cancelar o agendamento e atualizar o modal
    const cancelarAgendamento = async (id) => {
        const data = await ApiGestorMed.changeStatusAgendamento(id);
        if (data) {
            await updateAtendimentos(); // Atualiza os dados após o cancelamento
        }
    };

    // Função para abrir o modal e carregar os atendimentos
    const toggleNotifications = async () => {
        if (!showNotifications) { // Só carrega ao abrir
            await updateAtendimentos();
        }
        setShowNotifications(!showNotifications); // Alterna a visibilidade
    };

    const backClear = () => {
        navigate('/');
    };

    return (
        <>
            <div className="card_user_main">
                {/* Verifica se deve exibir o componente Notifications */}
                {/*{showNotifications && <Notifications cpf={props.dados.cpf} exibe={true} />}*/}
                {showNotifications &&
                    <ModalAtendimentos
                        able={showNotifications}
                        close={toggleNotifications}
                        atendimentos={atendimentos}
                        cancela={cancelarAgendamento}/>}
                {/* Menu Dropdown que contém as opções */}
                <Menu>
                    <MenuButton as={Button} rounded={'full'} variant={'link'} cursor={'pointer'} minW={0}>
                        <Avatar size="md" bg="#004587" name={props.dados.nome} color={'white'}>
                        </Avatar>
                    </MenuButton>
                    <MenuList>
                        {/* Exibe o nome e a categoria */}
                        <Box px={4} py={2}>
                            <div className="text_name_card">{props.dados.nome}</div>
                            <div className="text_categoria_card">{props.dados.categoria}</div>
                        </Box>

                        {/* Botão para abrir agendamentos */}
                        <MenuItem onClick={toggleNotifications}>
                            Meus Agendamentos
                        </MenuItem>

                        {/* Botão para sair */}
                        <MenuItem onClick={backClear} color="red">
                            Sair
                        </MenuItem>
                    </MenuList>
                </Menu>
            </div>
        </>
    );
}
